import React, { useEffect } from 'react';

export default function TermsOfUse() {
  useEffect(() => {
    document.title = 'Terms Of Use :: Productions.com';
  }, []);

  return (
    <section className="filmjob_section homepage terms">
      <div className="container font-dm">
        <div className="row">
          <h1 className="col-sm-12 filmjob_heading first">
            Productions.com Terms of Use
          </h1>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text first">
            These terms and conditions (“Terms of Use”) govern your use of the
            Productions.com website (as defined below) and any websites owned or
            operated by Productions.com including, without limitation,
            http://productions.com (the “Platform”) or the associated Services
            (as defined below). In these Terms of Use, Productions.com
            (“Productions.com”) may be referenced as “Productions.com ,” “we,”
            “us,” or “our”.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text bold">
            By accessing, browsing, downloading, using, or registering to
            receive the Platform or Services, you acknowledge that you have read
            and understood these Terms of Use and that you accept and agree to
            be bound by them in full. If you do not agree to these Terms of Use,
            do not use any portion of the Platform or the Services.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            In addition to describing the permitted uses of the Platform, these
            Terms of Use will provide you information on the following topics:
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            How we will notify you of changes in these Terms of Use;
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            Information on where to find our Privacy Policy;
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            Notice of your obligation to protect the security of your account
            and password;
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            Additional terms relating to your use of the Productions.com
            website;
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            Our grant of a limited license to use the Platform in accordance
            with these Terms of Use;
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            Notice of the types of use of the Platform that are prohibited
            and/or unlawful;
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            Notice of our copyright and proprietary rights in the Platform;
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            Our Digital Millennium Copyright Act (DMCA) Notice;
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            Description of your obligation to indemnify Productions.com for your
            use of the Platform;
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            Liability disclaimer that limits our liability to you;
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            General provisions such as the governing law and additional
            disclaimers; and
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            Information on how to contact Productions.com with any questions or
            comment about these Terms of Use or the Platform.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_subheading">
            Changes to the Terms of Use
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            We may update or modify these Terms of Use at any time effective
            upon posting the revised Terms of Use, along with the date on which
            it was most recently updated, on the Sites. We may give notice of
            such updates and modifications by any means, including without
            limitation, by posting a revised version of these Terms of Use on
            the Sites, or providing other notice on the Platform (“
            <strong>Notice</strong>”). All Notices will be effectively
            immediately. You should view these Terms of Use often to stay
            informed of any changes that may affect you. Your continued use of
            the Platform and/or the Services thereafter signifies your
            acceptance to such changes.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            The version of these Terms of Use posted on the Platform on each
            respective date you visit the Platform will be the Terms of Use
            applicable to your access and use of the Platform and Services on
            that date. Our electronically or otherwise properly stored copies of
            these Terms of Use and the Privacy Policy shall be deemed to be the
            true, complete, valid, authentic, and enforceable copies of the
            version of the Terms of Use and the Privacy Policy that were in
            force on each respective date you visited the Platform. We reserve
            the right to terminate these Terms of use, or to refuse, restrict,
            or discontinue access to the Platform or use of the Services (or any
            portions, components, or features thereof) to you or any other
            person or entity, for any reason or for no reason whatsoever, at any
            time, without notice or liability.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_subheading">Privacy Policy</div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            Productions.com’s privacy policy (the “Privacy Policy”) applies to
            your use of the Platform and the Services, and its terms are made a
            part of these Terms of Use by this reference. To view
            Productions.com’s Privacy Policy, please read it{' '}
            <a className="" href="/privacy">
              here
            </a>
            . We encourage you to read and become familiar with our privacy
            practices, as described in the Privacy Policy.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_subheading">
            Password Accounts, Passwords, and Security
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            In order to access the Platform, you must create an account with
            Productions.com and complete the registration process by providing
            us with current, complete and accurate information as prompted by
            the applicable registration form, including choosing a password and
            user name. You acknowledge and agree that you are not permitted to
            create more than one candidate user account on the Platform. You
            agree to: (a) provide true, accurate, current and complete
            information about yourself as prompted by the Platform registration
            mechanism (the “Registration Data”) and (b) maintain and promptly
            update the Registration Data to keep it true, accurate, current and
            complete. If you provide any information that is untrue, inaccurate,
            non-current or incomplete, or Productions.com has reasonable grounds
            to suspect that such information is untrue, inaccurate, non-current
            or incomplete, Productions.com has the right to suspend or terminate
            your account and refuse any and all current or future use of the
            Platform. You are entirely responsible for maintaining the
            confidentiality of your password and account and for any and all
            activities that occur under your account. You agree to (a)
            immediately notify us of any unauthorized use of your account or any
            other breach of security of which you become aware, and (b) exit
            completely from your account at the end of each online session. We
            will not be liable for any loss that you may incur as a result of
            someone else using your password or account, either with or without
            your knowledge. However, you could be held liable for losses
            incurred by us or another party due to someone else using your
            account or password. You may not use anyone else’s account at any
            time, without the permission of the account holder. You understand
            that you may voluntarily terminate your use of and delete your
            account from the Platform by using the applicable deactivation
            mechanism provided on the Platform.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            In consideration of your access to and use of the Platform, you
            represent that you are of legal age to form a binding contract and
            are not a person barred from accessing or using the Platform under
            the laws of the United States or other applicable jurisdiction. Only
            individuals who are of legal age to form a binding contract under
            applicable law (i.e., eighteen (18) years of age or older in most
            jurisdictions) are permitted to create an account or register to use
            the Platform.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_subheading">
            The Productions.com Website
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            If you access the Productions.com website using an Apple iOS or
            Android powered device, Apple Inc. or Google, Inc., and their
            subsidiaries, respectively, shall be a third-party beneficiary to
            this contract and you agree that these third-party beneficiaries
            have the right to enforce these Terms of Use against you. However,
            these third-party beneficiaries are not a party to these Terms of
            Use and are not responsible for the provision or support of the
            Productions.com website. You agree that your access to the
            Productions.com website shall also be subject to the usage terms set
            forth in the applicable third-party beneficiary’s terms of use.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            The Productions.com website may automatically download and install
            updates from time to time or require the downloading and
            installation of updates or new versions for continued use. You
            acknowledge that in some instances updates and/or new versions may
            reduce or remove features and functionality in prior versions of the
            Productions.com website.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_subheading">Premium Version</div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            If you buy any of Productions.com’s paid services (“Premium
            Services”), you agree to pay us the applicable fees and taxes and to
            any additional terms specific to the Premium Services provided to
            you at the time of your purchase or that may later apply to your
            continued use of the Premium Services. Your payments for Premium
            Services may be processed by third parties such as Apple through the
            Apple App Store or by Google through Google’s Google Play Store. If
            your payments are processed by third parties, additional terms and
            conditions may apply to you.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            Failure to pay the Premium Services fees will result in the
            termination of your Premium Services. Also, you agree that:
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            We may change, remove or add services and features to the Premium
            Services from time to time. We may also change our fees for Premium
            Services from time to time. You acknowledge our right to make such
            changes and agree that such changes do not entitle you to a refund
            of the fees paid for the Premium Services.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            We may store your payment method (e.g., credit card) to avoid
            interruptions in your Premium Services;
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            If you purchase a subscription, your payment method automatically
            will be charged at the start of each subscription period for the
            fees and taxes applicable to that period. To avoid future charges,
            cancel before the renewal date;
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            You authorize us to obtain updated or replacement expiration dates
            and card numbers for your credit or debit card as provided by your
            credit or debit card issuer. The terms of your payment will be based
            on your payment method and may be determined by agreements between
            you and the financial institution, credit card issuer or other
            provider of your chosen payment method; and
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            We may calculate taxes payable by you based on the billing
            information that you provide us at the time of purchase.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_subheading">
            Refunds for Premium Services
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            Generally, all charges for purchases on the Platform are
            nonrefundable, and there are no refunds or credits for partially
            used periods. We may make an exception of a refund for the fees that
            you paid for Premium Services if you request the refund within
            fourteen (14) days of the transaction date and you reside in the
            European Union (EU) or European Economic Area (EEA), or if the laws
            applicable in your jurisdiction provide for refunds. If you reside
            in Arizona, California, Connecticut, Illinois, Iowa, Minnesota, New
            York, North Carolina, Ohio or Wisconsin, you may cancel your Premium
            Services account, without penalty or obligation, at any time prior
            to midnight of the third business day following the original date of
            purchase of such Premium Services, excluding Sundays and holidays.
            In the event that you die before the end of your subscription period
            and you resided in Arizona, California, Connecticut, Illinois, Iowa,
            Minnesota, New York, North Carolina, Ohio or Wisconsin at the time
            of your death, your estate will be entitled to a refund of that
            portion of any payment you had made for your subscription which is
            allocable to the period after your death. In the event that you
            become disabled (such that you are unable to use the Services)
            before the end of your subscription period and you reside in
            Arizona, California, Connecticut, Illinois, Iowa, Minnesota, New
            York, North Carolina, Ohio or Wisconsin, you shall be entitled to a
            refund of that portion of any payment you had made for your
            subscription which is allocable to the period after your disability
            by providing the company notice in the same manner as you request a
            refund as described below.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_subheading">License Grant</div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            Productions.com grants you a personal, non-transferable, and
            non-exclusive right and license to use the Services via the Platform
            solely for your internal use, and subject to the condition that you
            do not (and do not allow any third party to) copy, modify, create a
            derivative work from, reverse engineer, reverse assemble or
            otherwise attempt to discover any source code, sell, assign,
            sublicense, grant a security interest in, or otherwise transfer any
            right in or access to the Platform or access to any products,
            information, or other content available therein.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            You agree not to use or launch any automated system (including
            “robots,” “spiders,” or “offline readers”) that access the Platform
            in a manner that sends more messages, requests, information, or
            content in a given period of time than can be reasonably performed
            by a human being. You further agree not to modify the Platform or
            any part thereof, in any form or manner, nor to use any modified
            versions of the Platform or other Productions.com products,
            software, or other content in order to gain unauthorized access to
            the Platform, or for any reason whatsoever, without the express
            written consent of Productions.com. You may not attempt to gain any
            unauthorized access to the Platform or any of its associated
            content, including computer systems, software, or networks.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            No commercial use or redistribution of any content, software, or
            other Productions.com products is permitted, unless expressly
            specified in a prior agreement between you and Productions.com.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            Productions.com reserves the right, in its sole discretion, to
            terminate your access to the Platform and the related Services or
            any portion thereof at any time, without notice.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_subheading">
            No Unlawful or Prohibited Use
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            As a condition of your use of the Platform or Services, you agree
            that you will not use the Platform or Services for any purpose that
            is unlawful or prohibited by these Terms of Use. You also agree to
            reimburse us for any damage, loss, cost or expense we incur,
            including any legal fees, because of your use of the Platform or the
            Services for an unlawful or prohibited purpose.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            You may not use the Services in any manner which could damage,
            disable, overburden, or impair the Platform or interfere with any
            other party’s use and enjoyment of the Platform or Services.
            Furthermore, you may not probe, scan, test the vulnerability of, or
            breach any security or authentication measures of the Platform. You
            may not obtain or attempt to obtain any materials or information
            through any means not intentionally made available or provided for
            through the Platform. Also, you may not register or attempt to
            register, any party for use or access to the Services, unless
            expressly authorized by such party to do so.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            The Platform may contain profiles, news feeds, chat areas, news
            groups, forums, communities, personal pages, calendars, and/or other
            message or communication facilities designed to enable you to
            communicate with a specified group or generally (collectively,
            “Communication Services”), you agree to use the Communication
            Services only to post, send and receive messages and material that
            are proper and related to the particular Communication Service. By
            way of example, and not as a limitation, you agree that when using a
            Communication Service, you will not:
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            Defame, abuse, harass, stalk, threaten or otherwise violate the
            legal rights (such as rights of privacy and publicity) of others;
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            Publish, post, upload, distribute or disseminate any inappropriate,
            profane, defamatory, infringing, obscene, indecent or unlawful
            topic; name, material or information;
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            Upload, post, transmit, or otherwise make available any contribution
            that infringes any patent, trademark, trade secret, copyright, or
            other proprietary right of any party;
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            Download any file posted by another user of a Communication Service
            that you know, or reasonably should know, cannot be legally
            distributed in such manner;
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            Falsify or delete any author attributions, legal or other proper
            notices or proprietary designations or labels of the origin or
            source of software or other material contained in a file that is
            uploaded;
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            Restrict or inhibit any other user from using and enjoying the
            Communication Services;
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            Violate any code of conduct or other guidelines which may be
            applicable for any particular Communication Service;
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            Harvest or otherwise collect information about others, including
            e-mail addresses, without their consent;
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            Harm minors in any way;
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            Impersonate any person or entity, or falsely state or otherwise
            misrepresent your affiliation with a person or entity;
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            “Stalk” or otherwise harass another person;
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            Use the Platform to conduct pyramid schemes, multi-level marketing
            or similar solicitations;
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            Use any robot, spider, scraper, or other automated or manual means
            to access the Platform or the Services, or copy any Platform Content
            or information thereon; or
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text list">
            Delete or revise any contribution made by another person or entity
            without their express consent, unless such activity is expressly
            permitted by the Service used.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            Productions.com has no obligation to monitor the Communication
            Services. However, Productions.com reserves the right to review
            materials posted to a Communication Service and to remove any
            materials in its sole discretion. Productions.com reserves the right
            to terminate your access to any or all of the Communication Services
            at any time without notice for any reason whatsoever. For clarity,
            the “Communication Services” and the Premium Services are included
            as part of the “Services.”
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            Productions.com reserves the right at all times to disclose any
            information as necessary to satisfy any applicable law, regulation,
            legal process or governmental request, or to edit, refuse to post or
            to remove any information or materials, in whole or in part, in
            Productions.com’s sole discretion.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            Always use caution when giving out any personally identifying
            information about yourself via the Services. Productions.com does
            not control or endorse the content, messages or information found in
            any Communication Service and, therefore, Productions.com
            specifically disclaims any liability with regard to the
            Communication Services and any actions resulting from your
            participation in any Communication Service.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            Materials uploaded to a Communication Service may be subject to
            posted limitations on usage, reproduction and/or dissemination. You
            are responsible for adhering to such limitations if you download the
            materials.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            Productions.com does not own the materials you provide to
            Productions.com (including feedback and suggestions) or post,
            upload, input or submit via the Platform or Services, including any
            Communication Services, and you may request deletion of any such
            materials at any time, unless such content has been shared with, or
            copied and stored by other users of the Platform or Services.
            However, by posting, uploading, inputting, providing or submitting
            such content you are granting Productions.com a nonexclusive,
            irrevocable, worldwide, sublicensable, perpetual, unlimited,
            assignable, fully paid up and royalty-free right to Productions.com
            to copy, publish, prepare derivative works of, distribute, process,
            analyze, use and commercialize, in any way now known or in the
            future discovered, such content.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            All content posted, uploaded, inputted, or submitted by you via the
            Platform is at your own risk and you hereby represent and warrant
            that you have the full legal right to so use such content and that
            it is not confidential or proprietary to any third party, nor are
            you using it in violation of any law or contractual restriction.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_subheading">
            Copyright and Proprietary Rights
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            Subject to the provisions of these Terms of Use relating to the
            ownership of personalized data, the Platform is the property of
            Productions.com and is protected by United States and International
            copyright laws. All copyright, trademark, patent, and other
            proprietary rights on the Platform and in the software, text,
            graphics, design elements, audio, music, and all other materials
            contributed or used by Productions.com in creation of the Platform
            or provision of the Services (“Platform Content”) are reserved to
            Productions.com and any other owners who have granted
            Productions.com the right and license to use such Platform Content.
            You may not reproduce, upload, post, transmit, download, or
            distribute any part of the Platform Content or information accessed
            at other sites through links made at the Platform (“Other Sites”).
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            You may not modify the Platform, Other Sites, or any material
            residing on such sites, except as specifically instructed or allowed
            in such sites. You shall observe copyright and other restrictions
            imposed by Other Sites. You may not use the Platform or Other Sites
            in any manner that infringes on the rights of any person or entity.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_subheading">
            Digital Millennium Copyright Act Compliance
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            If you believe that your work has been copied, posted, stored, or
            otherwise transmitted using the Platform in a way that constitutes
            copyright infringement, please provide the following information to
            the designated agent listed below:
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            (a) a clear and complete description of the copyrighted work that
            you claim has been infringed;
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            (b) a clear and complete description of the material on the Platform
            that you claim to be infringing and a sufficient description of
            where the material can be located to enable Productions.com to find
            and remove it;
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            (c) sufficient information to contact you, such as your address,
            telephone number, and email address;
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            (d) a statement by you that you have a good faith belief that use of
            the material in the manner complained of is not authorized by the
            copyright owner, its agent, or the law;
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            (e) a statement by you, made under penalty of perjury, that the
            information in your notification is accurate and that you are the
            owner, or an agent authorized to act on behalf of the owner, of an
            exclusive right that is allegedly infringed; and
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            (f) an electronic or physical signature of a person authorized to
            act on behalf of the owner of the copyright interest that is
            allegedly infringed.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            The designated agent for claims for copyright infringement may be
            reached at:
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            Productions.com
            <br />
            504 Fair St.
            <br />
            Atlanta, GA 30313
            <br />
            USA
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_subheading">Indemnification</div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            You agree to indemnify, defend and hold Productions.com and its
            affiliates harmless from and against all claims, demands, suits or
            other proceedings, and all resulting loss, damage, liability, cost,
            and expense (including attorneys’ fees), brought by any third party
            in connection with or arising out of content, data, or information
            that you submit, post to, or transmit through the Platform or
            Services, your access to and use of the Platform and/or Services,
            your violation of these Terms of use, your violation of any
            applicable law, regulation or code, or your violation of any rights
            of another. We reserve, and you grant to us, the right to assume
            exclusive defense and control of any matter subject to
            indemnification by you hereunder. All rights and duties of
            indemnification that are set forth herein shall survive termination
            of these Terms of use.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_subheading">
            Liability Disclaimer
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            THE INFORMATION, SOFTWARE, PRODUCTS, AND SERVICES PUBLISHED ON THE
            PLATFORM MAY INCLUDE INACCURACIES OR TYPOGRAPHICAL ERRORS. CHANGES
            ARE PERIODICALLY ADDED TO THE INFORMATION ON THE PLATFORM.
            PRODUCTIONS.COM, OUR PARTNERS, AFFILIATES, AND/OR OUR SUPPLIERS AND
            LICENSORS MAY MAKE IMPROVEMENTS AND/OR CHANGES IN THE PLATFORM AT
            ANY TIME.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            PRODUCTIONS.COM, OUR PARTNERS, OUR AFFILIATES, AND/OR OUR RESPECTIVE
            SUPPLIERS AND LICENSORS MAKE NO REPRESENTATIONS ABOUT THE
            SUITABILITY OF THE INFORMATION, SOFTWARE, PRODUCTS, AND SERVICES
            CONTAINED ON OR OBTAINED THROUGH THE PLATFORM FOR ANY PURPOSE. ALL
            SUCH INFORMATION, SOFTWARE, PRODUCTS, AND SERVICES ARE PROVIDED “AS
            IS” WITHOUT WARRANTY OF ANY KIND. PRODUCTIONS.COM, OUR PARTNERS, OUR
            AFFILIATES, AND/OR OUR RESPECTIVE SUPPLIERS AND LICENSORS HEREBY
            DISCLAIM ALL WARRANTIES AND CONDITIONS WITH REGARD TO THIS
            INFORMATION, SOFTWARE, PRODUCTS, AND SERVICES, INCLUDING ALL IMPLIED
            WARRANTIES AND CONDITIONS OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE, TITLE, AND NONINFRINGEMENT. PRODUCTIONS.COM AND
            OUR PARTNERS MAKE EVERY EFFORT TO PROTECT YOUR SECURITY, BUT,
            BECAUSE THE INTERNET IS AN INSECURE MEDIUM, NEITHER PRODUCTIONS.COM,
            NOR OUR PARTNERS, AFFILIATES, OR SUPPLIERS MAKE ANY REPRESENTATION
            OR WARRANTY THAT ANY TRANSACTION CONDUCTED THROUGH THE PLATFORM WILL
            NECESSARILY BE SECURE.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            IN NO EVENT SHALL PRODUCTIONS.COM, OUR PARTNERS, OUR AFFILIATES,
            AND/OR OUR RESPECTIVE SUPPLIERS AND LICENSORS BE LIABLE FOR ANY
            DIRECT, INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, OR CONSEQUENTIAL
            DAMAGES ARISING OUT OF OR IN ANY WAY CONNECTED WITH THE USE OF THE
            PLATFORM OR WITH THE DELAY OR INABILITY TO USE THE PLATFORM, OR FOR
            ANY INFORMATION, SOFTWARE, PRODUCTS, AND SERVICES OBTAINED THROUGH
            THE PLATFORM, OR OTHERWISE ARISING OUT OF THE USE OF THE PLATFORM,
            WHETHER BASED ON CONTRACT, TORT, STRICT LIABILITY, OR OTHERWISE,
            EVEN IF ANY OF PRODUCTIONS.COM, OUR PARTNERS, OUR AFFILIATES, AND/OR
            OUR RESPECTIVE SUPPLIERS AND LICENSORS HAS BEEN ADVISED OF THE
            POSSIBILITY OF DAMAGES.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            IN NO EVENT WILL THE AGGREGATE LIABILITY OF OUR PARTNERS, OUR
            AFFILIATES, AND OUR RESPECTIVE SUPPLIERS AND LICENSORS FOR ANY
            DAMAGES ARISING OUT OF OR RELATED TO ANY DEFAULT HEREUNDER,
            REGARDLESS OF THE FORM OF THE ACTION, EXCEED THE AMOUNT OF FEES
            ACTUALLY PAID BY YOU FOR USE OF THE PLATFORM. BECAUSE SOME
            STATES/JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION OF
            LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES, THE ABOVE
            LIMITATION MAY NOT APPLY TO YOU.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_subheading">General</div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            <span className="underline">Choice of Law; Venue</span>: These Terms
            of Use, as well as the Privacy Policy referenced herein, shall be
            governed by, and construed and enforced in accordance with, the laws
            of Georgia, USA without regard to its conflicts of laws principles.
            The United Nations Convention on Contracts for the International
            Sale of Goods is expressly disclaimed. You hereby consent to this
            choice of law, and to the exclusive jurisdiction and venue of the
            state and federal courts located in Fulton County, Georgia, USA for
            all disputes arising out of or relating to these Terms of Use and/or
            to the use of the Platform or Services. use of the Platform is
            unauthorized in any jurisdiction that does not give effect to all
            provisions of these terms and conditions, including without
            limitation this paragraph.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            <span className="underline">No Joint Venture</span>: You agree that
            no joint venture, partnership, employment, or agency relationship
            exists between you and Productions.com, our Partners, or any of our
            affiliates or suppliers as a result of these Terms of Use or use of
            the Platform.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            <span className="underline">Subject to Law</span>: Our performance
            of these Terms of Use, or the Privacy Policy referenced herein, is
            subject to existing laws and legal process, and nothing contained in
            these Terms of Use is in derogation of our right to comply with law
            enforcement requests or requirements relating to your use of the
            Platform or information provided to or gathered by us with respect
            to such use.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            <span className="underline">Severability</span>: If any part of
            these Terms of Use, or the Privacy Policy referenced herein, is
            determined to be invalid or unenforceable pursuant to applicable law
            including, but not limited to, the warranty disclaimers and
            liability limitations set forth above, then the invalid or
            unenforceable provision will be deemed superseded by a valid,
            enforceable provision that most closely matches the intent of the
            original provision and the remainder of these Terms of Use, or the
            referenced Privacy Policy, shall continue in effect.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            <span className="underline">Waiver</span>: Any waiver (express or
            implied) by either party of any breach of these Terms of Use, or the
            Privacy Policy referenced herein, shall not constitute a waiver of
            any other or subsequent breach.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            <span className="underline">Entire Agreement</span>: These Terms of
            Use, and the Privacy Policy referenced herein, and any additional
            agreements entered into between you and Productions.com constitute
            the entire agreement between you and us with respect to the Platform
            and the Services and it supersedes any and all prior or
            contemporaneous communications and proposals, whether electronic,
            oral, or written, between you, Productions.com, and/or our Partners
            with respect to the Platform, including prior versions of these
            Terms of Use and the associated Privacy Policy. A printed version of
            these Terms of Use and of any notice given in electronic form shall
            be admissible in judicial or administrative proceedings based upon
            or relating to these Terms of Use to the same extent and subject to
            the same conditions as other business documents and records
            originally generated and maintained in printed form
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            <span className="underline">Modification Right</span>: We reserve
            the right, at any time, to modify, alter, or update these Terms of
            Use or the Privacy Policy referenced herein. If we do so, we will
            post such modifications, alterations, or updates on the Platform,
            and your continued use of the Platform will constitute acceptance of
            such modifications, alterations, or updates.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            <span className="underline">Reservation of Rights</span>: Any rights
            not expressly granted herein are reserved.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            <span className="underline">
              No Editorial Control of Third Party Content; No Statement as to
              Accuracy
            </span>
            : To the extent that any of the content included in the Platform is
            provided by third party content providers or user, we have no
            editorial control or responsibility over such content. Therefore,
            any opinions, statements, products, services or other information
            expressed or made available by third party suppliers or user on the
            Platform are those of such third party suppliers or users. We do not
            represent or endorse the accuracy or reliability of any opinion,
            statement or other information provided by any third party, or
            represent or warrant that your use of such content or referenced
            content or service providers will not infringe rights of third
            parties not owned by or affiliated with us.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            <span className="underline">Links to Third Party Sites</span>: The
            Platform may contain hyperlinks to other sites owned and operated by
            parties other than us. Such hyperlinks are provided only for ready
            reference and ease of use. We do not control such websites and
            cannot be held responsible for their content or accuracy and do not
            endorse these sites unless we specifically so state. In the event
            the Platform provides hyperlinks to other websites that are not
            owned, operated or maintained by us, you acknowledge and agree that
            we are not responsible for and are not liable for the content,
            products, services or other materials on or available from such
            websites. We accept no liability for any information, products,
            advertisements, content, services or software accessible through
            these third party websites or for any action you may take as a
            result of linking to any such website. Any such websites are likely
            to set forth specific terms of use and privacy policies that you
            should review. We are under no obligation to maintain any link on
            the Platform and may remove a link at any time in our sole
            discretion for any reason whatsoever. We shall not be responsible or
            liable, directly or indirectly, for any damages or losses caused or
            alleged to be caused by or in connection with the use of or reliance
            on such content, products, services or other materials available on
            or through any such website. We are not responsible for the privacy
            practices of any other websites.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            <span className="underline">Disclaimer</span>: Content and other
            information contained on the Platform has been prepared by us as a
            convenience to its users and is not intended to constitute advice or
            recommendations upon which a user may rely. We have used reasonable
            efforts in collecting, preparing and providing quality information
            and material, but make no warranty or guarantee about the accuracy,
            completeness, or adequacy of the content or other information
            contained in or linked to the Platform or any other website
            maintained by us. users relying on content or other information from
            the Platform do so at their own risk.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            The information and descriptions contained herein are not intended
            to be complete descriptions of the terms, exclusions and conditions
            applicable to the products and services described herein, but are
            provided solely for general informational purposes; please refer to
            the actual lease or the relevant product or services agreement for
            complete terms and conditions. Should you lease a property from us
            or purchase a product or service from a third party, the terms and
            conditions applicable to that transaction will govern such rental or
            purchase, as applicable, and your use of the Platform does not
            affect that purchase in any manner.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            <span className="underline">Notices</span>: Any notices to you from
            us regarding the Platform or these Terms of Use will be posted on
            the Platform, provided via Communication Services, or made by email.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            <span className="underline">Electronic Communications</span>: When
            you visit the Platform or send emails or other messages via the
            Platform to us, you are communicating with us electronically. You
            consent to receive communications from us electronically. We will
            communicate with you by e-mail or by posting notices on the
            Platform. You agree that all agreements, notices, disclosures and
            other communications that we provide to you electronically,
            including those provided via the Platform, satisfy any legal
            requirement that such communications be in writing. You further
            agree that any notices provided by us electronically are deemed to
            be given and received on the date we transmit any such electronic
            communication as described in these Terms of Use.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            <span className="underline">Partners</span>: For purposes of these
            Terms of Use, and the Privacy Policy referenced herein, “
            <span className="underline">Partner</span>” shall mean any person or
            company with whom Productions.com has entered into a legal
            arrangement for joint provision of or shared responsibility for the
            Platform or the Services.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            <span className="underline">Remedies</span>: You agree that any
            violation, or threatened violation, by you of these Terms of Use, or
            the referenced Privacy Policy, constitutes an unlawful and unfair
            business practice that will cause us irreparable and unquantifiable
            harm. You also agree that monetary damages would be inadequate for
            such harm and consent to our obtaining any injunctive or equitable
            relief that we deem necessary or appropriate. These remedies are in
            addition to any other remedies we may have at law or in equity.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_subheading">
            Contact Productions.com about our Terms of Use and Privacy Policy
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            If you have any questions or comments about these Terms of Use or
            other Productions.com policies relating to use of the Platform,
            please contact us at hello@productions.com, or send a letter to:
            Productions.com, 504 Fair St. Atlanta GA 30313.
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 filmjob_text">
            These Terms of Use were last updated and posted on July 2, 2021.
          </div>
        </div>
      </div>
    </section>
  );
}
